import React from 'react';
import './CSS/Footer.css';

function Footer() {
  return (
    <div className="Footer">
      <div className="Copyright">
        <h4>Designed by Emem Cookey </h4>
        <p>Copyright @ 2022</p>
      </div>
    </div>
  );
}

export default Footer;
